// extracted by mini-css-extract-plugin
export default {"box":"LgH1ycP9gll9Acb7lWA6","image":"bYgNDuv5jyI2jQcL2IeQ"};